<template>
  <!-- Body -->
  <div class="d-flex flex-column align-center">
    <div id="building">
      <div id="building-middle"></div>
      <div id="building-base"></div>
      <v-img @click="enter" @mouseover="isOpen = true" @mouseleave="isOpen = false" id="entrance" :src="isOpen ? srcOpen : srcClose" lazy></v-img>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    isOpen: false,
    srcClose: require('@/assets/world/buildings/WorldBuildingTowerEntrance.png'),
    srcOpen: require('@/assets/world/buildings/WorldBuildingTowerEntranceOpen.png'),
  }),
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    enter() {
      this.$intro().exit();
      this.isOpen = true;
      this.$router.push({ name: "PageMath" });
    },
  },
};
</script>

<style scoped>
#building {
  position: absolute;
  width: 100vw;
  height: 100vh;
  bottom: 180px;
  background-size: auto;
  background-position: center bottom;
}

#building-base {
  position: absolute;
  background-image: url("../../../assets/world/buildings/WorldBuildingTower_960x512.png");
  width: 100vw;
  height: 100vh;
  bottom: 0;
  background-size: auto;
  background-position: center bottom;
}

#building-middle {
  position: absolute;
  background-image: url("../../../assets/world/buildings/WorldBuildingTowerMiddle.png");
  width: 100vw;
  height: 100vh;
  bottom: 225px;
  background-size: auto;
  background-position: center bottom;
  background-repeat: repeat-y;
}

#entrance {
  cursor: pointer;
  position: absolute;
  width: 107px;
  height: 123px;
  bottom: 54px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  filter:
    drop-shadow(3px 0 0 rgba(255,255,255,0.3))
    drop-shadow(-3px 0 0 rgba(255,255,255,0.3))
    drop-shadow(0 3px 0 rgba(255,255,255,0.3))
    drop-shadow(0 -3px 0 rgba(255,255,255,0.3));
}

#entrance:hover {
  filter:
    drop-shadow(0 0 4px rgba(255, 255, 0, 0.8))
    drop-shadow(0 0 8px rgba(255, 255, 0, 0.6))
    drop-shadow(0 0 12px rgba(255, 255, 0, 0.4));
}
</style>